import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from '../../helpers/dateTime';
import DetailsCostMessaging from './detailsCostMessaging';
import { logUI } from "../../api/andyliticsApi";
import useSelfPayDiscount from "./hooks/useSelfPayDiscount";


const DetailsCostSelfPay = props => {
    const { benefitDetails, tileName, pricingCOVIDMessage } = props;
    const bd = benefitDetails;//benefitDetails &&   
    const { patientFinancialResponsibility } = bd.patientFinancialResponsibilityDetail;  
    const discount = useSelfPayDiscount(bd.providerInformation.environment);
    const realAmount = Number(patientFinancialResponsibility) / Number(discount);
    const discountAmount = realAmount - patientFinancialResponsibility;
    //const patientCost = //Number(patientFinancialResponsibility) - Number(discountAmount);
    //debugger;


        return <div className="row estimate-details-cost-container">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <div className="row">
                            <div className="col-12 col-lg-7">
                                <div className="card-heading">
                                    {tileName}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body pt-0">
                        <div className="row">
                            <div className="col-12 col-lg-7 order-1">
                                <div className="estimate-details-cost">{formatMoney(patientFinancialResponsibility)}</div>
                                <div className={`estimate-details-covered `}>SELF-PAY DISCOUNT: <span>{formatMoney(discountAmount)}</span></div>
                            </div>
                            <div className="col-12 col-lg-5 order-3 order-lg-2">
                                <div className="row hidden">
                                    <div className="col">
                                        <div className="estimate-details-update">
                                            <div className="row">
                                                <div className="col estimate-details-update-info">Estimate created on {formatDate(bd.dateOfService, { month: "long", day: "2-digit", year: "numeric" })}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col"><a className="estimate-details-update-link" href="#blank">UPDATE NOW</a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <DetailsCostMessaging benefitDetails={bd} isSelfPay={true} pricingCOVIDMessage={pricingCOVIDMessage}/>
                            <div className="col-12 col-xl-3 order-4 text-right payment-options-footer">
                                <Link className="card-link" to="/estimates/paymentOptions">PAYMENT OPTIONS</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
 
}

const formatMoney = (amount) => {
    console.info(`detailsCostTile formatMoney amount ${amount} is number ${!isNaN(amount)}`, amount);
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return formatter.format(amount);
}

export default DetailsCostSelfPay;

